export function playlistRecoveryScope(workspace) {
  const me = workspace?.me;
  return me?.organizationId && me?.userId ? `${encodeURIComponent(me.organizationId)}:${encodeURIComponent(me.userId)}` : null;
}

export class PlaylistCreateRecovery {
  constructor(storage) { this.storage = storage; }
  key(scope) { if (!scope) throw new Error("Sign in before saving a Cloud playlist.");return `pirdy.playlist-create.v1:${scope}`; }
  list(scope) {
    if (!scope) return [];
    const encoded = this.storage?.getItem(this.key(scope));
    const records = encoded ? JSON.parse(encoded) : [];
    if (!Array.isArray(records) || records.some(item => !item?.request?.requestId || !Array.isArray(item.request.items) || typeof item.request.name !== "string")) throw new Error("The unfinished playlist-save record is invalid. It was retained; no new playlist was created.");
    return records;
  }
  write(scope, records) {
    if (!this.storage) throw new Error("This browser cannot store safe save-recovery data. Enable site storage or use the Customer App; nothing was created.");
    const value = JSON.stringify(records);this.storage.setItem(this.key(scope), value);
    if (this.storage.getItem(this.key(scope)) !== value) throw new Error("The browser could not verify the save-recovery record. Nothing was created.");
  }
  stage(scope, payload, requestId) {
    const records = this.list(scope);
    let record = requestId ? records.find(item => item.request.requestId === requestId) : null;
    if (requestId && !record) throw new Error("The original save-recovery record is unavailable. Refresh your Cloud playlists before creating another copy.");
    if (!record) { record = { request: { ...JSON.parse(JSON.stringify(payload)), requestId: globalThis.crypto.randomUUID() }, desired: payload };records.push(record); }
    record.desired = JSON.parse(JSON.stringify(payload));this.write(scope, records);return record;
  }
  complete(scope, requestId) { this.write(scope, this.list(scope).filter(item => item.request.requestId !== requestId)); }
}

let storage;
try { storage = globalThis.localStorage; } catch { /* Writes remain disabled until durable browser storage works. */ }
export const playlistCreateRecovery = new PlaylistCreateRecovery(storage);
